/**
 * DEV ONLY — the simulated-day stepper above the Live cards: which day the
 * page is looking at, Next day (generates that day for real — drafts only,
 * cursors read — and moves the clock), Back to today, and Clear simulation.
 * Renders only when the backend says the simulation is on.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { CalendarPlus, FlaskConical, RotateCcw, Undo2 } from 'lucide-react';

const BTN =
  'inline-flex items-center gap-1 rounded-md border border-input px-2 py-1 text-[11px] font-medium text-muted-foreground hover:bg-muted hover:text-foreground disabled:opacity-50';

const dayLabel = (iso: string | null, runDate: string | undefined) => {
  const date = runDate ? runDate.split('-').reverse().join('/') : '—';
  return iso ? `simulated day · ${date}` : `today · ${date}`;
};

export const SimulationBar: FC<{
  at: string | null;
  runDate: string | undefined;
  onNextDay: () => void;
  onBackToToday: () => void;
  onClear: () => void;
  busy?: boolean;
}> = ({ at, runDate, onNextDay, onBackToToday, onClear, busy = false }) => (
  <div className="flex flex-wrap items-center gap-2 rounded-md border border-dashed border-primary/40 bg-primary/5 px-3 py-2 text-xs">
    <FlaskConical className="h-3.5 w-3.5 text-primary" />
    <span className="font-semibold text-primary">Simulation</span>
    <span className="text-muted-foreground">
      development tool — fake sends, nothing on SMSWiser · {dayLabel(at, runDate)}
    </span>
    <span className="grow" />
    <button type="button" className={BTN} onClick={onNextDay} disabled={busy} title="Generate tomorrow for real (drafts only, nothing on SMSWiser). Today's unsent drafts are swept as every morning — Generate today again to get them back. Burned lists are skipped; the clock moves.">
      <CalendarPlus className="h-3 w-3" /> Next day
    </button>
    {at ? (
      <button type="button" className={BTN} onClick={onBackToToday} disabled={busy}>
        <Undo2 className="h-3 w-3" /> Back to today
      </button>
    ) : null}
    <button type="button" className={BTN} onClick={onClear} disabled={busy} title="Forget every fake send and remove the simulated days (burned lists stay — Reset pool forgives them)">
      <RotateCcw className="h-3 w-3" /> Clear simulation
    </button>
  </div>
);
